// Decides whether the Saras rail should jump to the live Chat ("active") view.
// Fires when a conversation is selected (e.g. resumed from a Home card) and its
// history is present, from any mode except an already-active chat or the History tab (whose in-place
// session viewer must stay put when the user taps a session).
export function shouldSwitchToActive({
  panelMode,
  hasActiveConversation,
  selectedConversationId,
}) {
  if (panelMode === "active" || panelMode === "history") return false;
  if (!hasActiveConversation) return false;
  if (panelMode === "idle") return true;
  return selectedConversationId != null;
}
